import { useCallback, useEffect, useMemo, useRef, useState } from "react";

export function useSecretSequence(
  sequence: string[],
  onUnlock?: () => void,
  listenOn: Window | Document = window
) {
  const seq = useMemo(() => sequence.map(normalizeKey), [sequence]);
  const [index, setIndex] = useState(0);
  const [unlocked, setUnlocked] = useState(false);
  const unlockedRef = useRef(false);

  const reset = useCallback(() => {
    setIndex(0);
    setUnlocked(false);
    unlockedRef.current = false;
  }, []);

  const handler = useCallback(
    (event: Event) => {
      const e = event as KeyboardEvent;
      if (!seq.length) return;

      const k = normalizeKey(e.key);

      // se já desbloqueou, ignora;
      if (unlockedRef.current) return;

      if (k === seq[index]) {
        // avança
        const next = index + 1;
        setIndex(next);

        if (next === seq.length) {
          setUnlocked(true);
          unlockedRef.current = true;
          onUnlock?.();
        }
      } else {
        // erro: porém, se a tecla atual é igual ao início da sequência, recomeça de 1
        if (k === seq[0]) {
          setIndex(seq.length === 1 ? 0 : 1);
          // se a sequência tem 1 item, já completa imediatamente
          if (seq.length === 1) {
            setUnlocked(true);
            unlockedRef.current = true;
            onUnlock?.();
          }
        } else {
          // reset total
          setIndex(0);
        }
      }
    },
    [index, onUnlock, seq]
  );

  useEffect(() => {
    listenOn.addEventListener("keydown", handler);
    return () => listenOn.removeEventListener("keydown", handler);
  }, [handler, listenOn]);

  return { index, unlocked, reset };
}

function normalizeKey(k: string) {
  if (k === " ") return "Space";
  return /^[a-z]$/i.test(k) ? k.toLowerCase() : k;
}
